import { ref } from "@vue/composition-api";
import useAppConfig from "@core/app-config/useAppConfig";

export default function useAppCustomizer() {
  // Customizer
  const isCustomizerOpen = ref(false);

  // Skin
  const skinOptions = [
    { text: "Clair", value: "light" },
    { text: "Bordé", value: "bordered" },
    { text: "Sombre", value: "dark" },
    { text: "Mi-Sombre", value: "semi-dark" },
  ];

  // Content Width Options
  const contentWidthOptions = [
    { text: "Plein Ecran", value: "full" },
    { text: "Encadrée", value: "boxed" },
  ];

  // Router Transition
  const routerTransitionOptions = [
    { title: "Zoom -", value: "zoom-fade" },
    { title: "Estomper", value: "fade" },
    { title: "Estomper en Bas", value: "fade-bottom" },
    { title: "Grissement", value: "slide-fade" },
    { title: "Zoom +", value: "zoom-out" },
    { title: "Aucun", value: "none" },
  ];

  // Router Transition
  const layoutTypeOptions = [
    { text: "Verticale", value: "vertical" },
    { text: "Horizontale", value: "horizontal" },
  ];

  // Navbar
  const navbarColors = [
    "",
    "primary",
    "secondary",
    "success",
    "danger",
    "warning",
    "info",
    "dark",
  ];

  // Navbar Types
  const navbarTypes = [
    { text: "Flotant", value: "floating" },
    { text: "Lié", value: "sticky" },
    { text: "Statique", value: "static" },
    { text: "Masqué", value: "hidden" },
  ];

  // Footer Types
  const footerTypes = [
    { text: "Lié", value: "sticky" },
    { text: "Statique", value: "static" },
    { text: "Masqué", value: "hidden" },
  ];

  // eslint-disable-next-line object-curly-newline
  const {
    isRTL,
    skin,
    contentWidth,
    routerTransition,
    layoutType,
    isNavMenuHidden,
    isVerticalMenuCollapsed,
    navbarBackgroundColor,
    navbarType,
    footerType,
  } = useAppConfig();

  return {
    // Customizer
    isCustomizerOpen,

    // Vertical Menu
    isVerticalMenuCollapsed,

    // Skin
    skin,
    skinOptions,

    // Content Width
    contentWidth,
    contentWidthOptions,

    // RTL
    isRTL,

    // routerTransition
    routerTransition,
    routerTransitionOptions,

    // Layout Type
    layoutType,
    layoutTypeOptions,

    // NavMenu Hidden
    isNavMenuHidden,

    // Navbar
    navbarColors,
    navbarTypes,
    navbarBackgroundColor,
    navbarType,

    // Footer
    footerTypes,
    footerType,
  };
}
